import React, {forwardRef, useState} from 'react';
import axios from 'axios';
import {ContactStyle, TextStyle} from '../assets/css/Styles';
import {Form, FloatingLabel, Button, Container, Col} from 'react-bootstrap';
import MainTitle from './MainTitle';

export const Contact = forwardRef(({...props}, ref) => {
  const [buttonActive, setButtonActive] = useState(false);
  const [fullName, setFullName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [message, setMessage] = useState('');
  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  /**
   * reset all input error messages
   */
  const resetError = () => {
    if (nameError) setNameError(false);
    if (emailError) setEmailError(false);
    if (messageError) setMessageError(false);
    if (invalidEmail) setInvalidEmail(false);
  };

  /**
   * reset all input contents
   */
  const resetInput = () => {
    if (fullName.length !== 0) setFullName('');
    if (emailAddress.length !== 0) setEmailAddress('');
    if (message.length !== 0) setMessage('');
  };

  /**
   * @param {String} senderName - updated name from input
   */
  const handleNameChange = (senderName) => {
    setFullName(senderName);
    resetError();
  };

  /**
   * @param {String} senderEmail - updated email from input
   */
  const handleEmailChange = (senderEmail) => {
    setEmailAddress(senderEmail);
    resetError();
  };

  /**
   * @param {String} senderMessage - updated message from input
   */
  const handleMessageChange = (senderMessage) => {
    setMessage(senderMessage);
    resetError();
  };

  /**
   * @return {function} send email or return error
   */
  const handleSendEmail = () => {
    if (fullName.length === 0) return setNameError(true);
    else if (emailAddress.length === 0) return setEmailError(true);
    else if (!emailAddress.includes('@')) return setInvalidEmail(true);
    else if (message.length === 0) return setMessageError(true);
    else {
      const requestBody = {
        name: fullName,
        email: emailAddress,
        message: message,
      };
      axios.post('https://clement-portfolio-backend.herokuapp.com', requestBody)
      // axios.post('http://localhost:9000', requestBody)
          .then((response) => {
            console.log(response);
            if (response.status === 200) alert('Message sent successfully');
            else alert('Server error, Try again');
          })
          .catch((err) => {
            alert('Something went wrong, Try again');
            console.log('Request error: ', err);
          });
      /*
      const requestOptions = {
        method: 'POST',
        mode: 'cors',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: JSON.stringify({
          name: fullName,
          email: emailAddress,
          message: message,
        }),
      };

      fetch('https://clement-portfolio-backend.herokuapp.com', requestOptions)
      // fetch('http://localhost:9000', requestOptions)
          .then((response) => {
            if (response.ok) alert('Message sent successfully');
            else alert('Something went wrong, Try again');
          })
          .catch((err) => {
            alert('Something went wrong, Try again');
          });
          */
      return resetInput();
    }
  };

  return (
    <Container ref={ref} style={ContactStyle.contactContainer}>
      <MainTitle title='CONTACT' />
      <Col style={ContactStyle.contactIntroTxt}>
        <span style={TextStyle.normalTxt1}>
            Have a question or want to work together?
        </span>
      </Col>
      <Form.Group style={ContactStyle.contactFormDiv} as='div'>
        <FloatingLabel
          label='Full name'
          controlId='floatingInput'
          style={ContactStyle.eachInput}>
          <Form.Control
            as='input'
            type='name'
            placeholder='Full name'
            htmlSize={50}
            value={fullName}
            onChange={(nameTxt) => handleNameChange(nameTxt.target.value)}
          />
        </FloatingLabel>
        {
          nameError && <Col style={ContactStyle.inputErrorTxt}>
            <span style={TextStyle.normalTxt3}>
            Name should not be empty
            </span>
          </Col>
        }
        <FloatingLabel
          label='Email address'
          controlId='floatingInput'
          style={ContactStyle.eachInput}>
          <Form.Control
            as='input'
            type='email'
            placeholder='Email address'
            htmlSize={50}
            value={emailAddress}
            onChange={(emailTxt) => handleEmailChange(emailTxt.target.value)}
          />
        </FloatingLabel>
        {
          emailError ?
          (<Col style={ContactStyle.inputErrorTxt}>
            <span style={TextStyle.normalTxt3}>
            Email should not be empty
            </span>
          </Col>) :
          (invalidEmail && <Col style={ContactStyle.inputErrorTxt}>
            <span style={TextStyle.normalTxt3}>
            Invalid email
            </span>
          </Col>)
        }
        <FloatingLabel
          label='Your Message'
          controlId='floatingInput'
          style={ContactStyle.eachInput}>
          <Form.Control
            as='textarea'
            type='text'
            placeholder='Your Message'
            htmlSize={50}
            style={ContactStyle.eachInputMessage}
            value={message}
            onChange={(msgTxt) => handleMessageChange(msgTxt.target.value)}
            // size='lg'
          />
        </FloatingLabel>
        {
          messageError && <Col style={ContactStyle.inputErrorTxt}>
            <span style={TextStyle.normalTxt3}>
              Message should not be empty
            </span>
          </Col>
        }

        <Col style={ContactStyle.submitButtonDiv}>
          <Button
            style={
              buttonActive ?
               ContactStyle.submitButtonActive :
               ContactStyle.submitButton}
            onMouseEnter={() => setButtonActive(true)}
            onMouseLeave={() => setButtonActive(false)}
            onClick={() => handleSendEmail()}>
            <span style={TextStyle.normalTxt1}>Submit</span>
          </Button>
        </Col>
      </Form.Group>
    </Container>
  );
});
